import '@sad5/tokens/theme.css';
import '@sad5/ui/styles.css';
import './styles.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { PortalRouter } from './public-router.js';

import { App } from './app.js';
import { applyStoredTheme } from './theme.js';

applyStoredTheme();

const root = document.querySelector<HTMLDivElement>('#root');
if (!root) throw new Error('Brak elementu #root');

createRoot(root).render(
  <StrictMode>
    <PortalRouter>
      <App />
    </PortalRouter>
  </StrictMode>,
);
